import { useMediaQuery } from "react-responsive"
import React, { useEffect, useState } from "react"
import MachineDesktop from "./MachineDesktop"
import MachineMobile from "./MachineMobile"
import { MachineProps } from "@/app/interface/components"

const Machine: React.FC<MachineProps> = ({ model, modelData }) => {
    const isDesktop = useMediaQuery({ minWidth: 1140 })
    const [isMounted, setIsMounted] = useState(false)

    useEffect(() => {
        setIsMounted(true)
    }, [])

    // Renderiza nulo até que o componente esteja montado para evitar problemas de hidratação
    if (!isMounted) {
        return null
    }

    return (
        <>
            { isDesktop ? <MachineDesktop model={model} modelData={modelData} /> : <MachineMobile model={model} modelData={modelData} /> }
        </>
    )
}

export default React.memo(Machine)
